import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TrainingEventEntity } from './training-event.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum TrainingEventActionTypes {
  LoadTrainingEvents = '[TrainingEvent] Load TrainingEvents',
  AddTrainingEvent = '[TrainingEvent] Add TrainingEvent',
  UpsertTrainingEvent = '[TrainingEvent] Upsert TrainingEvent',
  AddTrainingEvents = '[TrainingEvent] Add TrainingEvents',
  UpsertTrainingEvents = '[TrainingEvent] Upsert TrainingEvents',
  UpdateTrainingEvent = '[TrainingEvent] Update TrainingEvent',
  UpdateTrainingEvents = '[TrainingEvent] Update TrainingEvents',
  DeleteTrainingEvent = '[TrainingEvent] Delete TrainingEvent',
  DeleteTrainingEvents = '[TrainingEvent] Delete TrainingEvents',
  ClearTrainingEvents = '[TrainingEvent] Clear TrainingEvents',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadTrainingEvents implements Action {
  public readonly type = TrainingEventActionTypes.LoadTrainingEvents;

  constructor(public payload: { trainingEvents: TrainingEventEntity[] }) {}
}

export class AddTrainingEvent implements Action {
  public readonly type = TrainingEventActionTypes.AddTrainingEvent;

  constructor(public payload: { trainingEvent: TrainingEventEntity }) {}
}

export class UpsertTrainingEvent implements Action {
  public readonly type = TrainingEventActionTypes.UpsertTrainingEvent;

  constructor(public payload: { trainingEvent: TrainingEventEntity }) {}
}

export class AddTrainingEvents implements Action {
  public readonly type = TrainingEventActionTypes.AddTrainingEvents;

  constructor(public payload: { trainingEvents: TrainingEventEntity[] }) {}
}

export class UpsertTrainingEvents implements Action {
  public readonly type = TrainingEventActionTypes.UpsertTrainingEvents;

  constructor(public payload: { trainingEvents: TrainingEventEntity[] }) {}
}

export class UpdateTrainingEvent implements Action {
  public readonly type = TrainingEventActionTypes.UpdateTrainingEvent;

  constructor(public payload: { trainingEvent: Update<TrainingEventEntity> }) {}
}

export class UpdateTrainingEvents implements Action {
  public readonly type = TrainingEventActionTypes.UpdateTrainingEvents;

  constructor(public payload: { trainingEvents: Update<TrainingEventEntity>[] }) {}
}

export class DeleteTrainingEvent implements Action {
  public readonly type = TrainingEventActionTypes.DeleteTrainingEvent;

  constructor(public payload: { id: string }) {}
}

export class DeleteTrainingEvents implements Action {
  public readonly type = TrainingEventActionTypes.DeleteTrainingEvents;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTrainingEvents implements Action {
  public readonly type = TrainingEventActionTypes.ClearTrainingEvents;
}

export type TrainingEventActions =
  | LoadTrainingEvents
  | AddTrainingEvent
  | UpsertTrainingEvent
  | AddTrainingEvents
  | UpsertTrainingEvents
  | UpdateTrainingEvent
  | UpdateTrainingEvents
  | DeleteTrainingEvent
  | DeleteTrainingEvents
  | ClearTrainingEvents;
